import { Helmet } from "react-helmet-async";

const BASE = "https://smartnagarnigam.com";
const OG_IMAGE = "https://images.unsplash.com/photo-1769271972348-429a8ad18f51";

const SEO = ({ title, description, path = "/", type = "website" }) => {
  const fullTitle = title
    ? `${title} — Smart Nagar Nigam`
    : "Smart Nagar Nigam — Civic Intelligence · Better Cities · Empowered Citizens";
  const url = `${BASE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
};

export default SEO;
